import React from 'react';
import { Skeleton } from './ui/skeleton';

export function EventCardSkeleton() {
  return (
    <div className="bg-card rounded-2xl overflow-hidden border animate-pulse">
      {/* Image Skeleton */}
      <Skeleton className="w-full h-48 bg-muted" />
      
      {/* Content */}
      <div className="p-6 space-y-4">
        {/* Date Badge */}
        <Skeleton className="w-20 h-6 bg-muted" />
        
        {/* Title */}
        <Skeleton className="w-full h-6 bg-muted" />
        <Skeleton className="w-3/4 h-6 bg-muted" />
        
        {/* Location and Time */}
        <div className="space-y-2">
          <Skeleton className="w-2/3 h-4 bg-muted" />
          <Skeleton className="w-1/2 h-4 bg-muted" />
        </div>
        
        {/* Price */}
        <div className="flex justify-between items-center">
          <Skeleton className="w-24 h-6 bg-muted" />
          <Skeleton className="w-20 h-10 bg-muted rounded-lg" />
        </div>
      </div>
    </div>
  );
}

export function EventGridSkeleton({ count = 9 }: { count?: number }) {
  return (
    <div className="event-grid-responsive">
      {Array.from({ length: count }).map((_, index) => (
        <EventCardSkeleton key={index} />
      ))}
    </div>
  );
}